export function preconnect(origin: string, crossOrigin = false): void {
  const match = crossOrigin ? '[crossorigin]' : ':not([crossorigin])';

  if (document.querySelector(`link[rel="preconnect"][href="${origin}"]${match}`)) return;

  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = origin;

  if (crossOrigin) link.crossOrigin = 'anonymous';

  document.head.appendChild(link);
}

const pendingScripts = new Map<string, Promise<void>>();

function startScript(src: string): Promise<void> {
  const loading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');

    script.addEventListener('load', () => {
      script.dataset.loaded = '';
      resolve();
    }, { once: true });

    script.addEventListener('error', () => {
      script.remove();
      pendingScripts.delete(src);
      reject(new Error(`Payment script failed to load: ${src}`));
    }, { once: true });

    script.src = src;
    script.async = true;
    document.head.appendChild(script);
  });

  pendingScripts.set(src, loading);

  return loading;
}

export function dropScript(src: string): void {
  document.querySelector(`script[src="${src}"]`)?.remove();
  pendingScripts.delete(src);
}

export function loadScript(src: string, timeoutMs: number): Promise<void> {
  if (document.querySelector(`script[src="${src}"][data-loaded]`)) {
    return Promise.resolve();
  }

  const loading = pendingScripts.get(src) ?? startScript(src);

  return new Promise<void>((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(`Payment script timed out: ${src}`)), timeoutMs);

    loading.then(resolve, reject).finally(() => clearTimeout(timer));
  });
}
